/**
 * FullStory masking configuration.
 *
 * FS_MASK_QUESTION_IDS_2003   – question_id substrings masked when role === '2003'.
 * FS_MASK_QUESTION_IDS_CLIENT – question_id substrings masked when role === 'client'.
 *
 * Comparison is substring-based: 'EmailLabel2' matches 'EmailLabel2_1', 'EmailLabel2_2', etc.
 */

/**
 * Some products (e.g. the Accident/IOA questionnaire) key a handful of
 * sensitive questions with single-letter ids ('f' = billing mode, 'm' =
 * payment method) instead of descriptive names. Substring matching against
 * those would match almost every question_id in the app, so they're checked
 * by exact equality only, regardless of role.
 */
export const FS_MASK_QUESTION_IDS_EXACT = [
  'f',
  'm',
];

export const FS_MASK_QUESTION_IDS_2003 = [
  'EmailLabel2',
  'SelectedCoverage',
  'OfferProductType',
  'OfferCoverageType',
  'OfferFaceAmount',
  'MemberDateOfBirth',
  'BeneDateOfBirth',
  'PrimaryBeneDateOfBirth',
  'ContingentBeneDateOfBirth',
  'ConfirmationNumber',
  'Coverage',
  'ExistingPolicies',
  'BeneFirstName',
  'BeneFirstNameASGIWL',
  'BeneMiddleName',
  'BeneLastName',
  'BeneLastNameASGIWL',
  'BeneRelationship',
  'BeneStreetAddress',
  'BeneAddress2',
  'BeneCity',
  'BeneState',
  'BeneZIPCode',
  'PrimaryBeneType',
  'PrimaryBeneFirstName',
  'PrimaryBeneMiddleName',
  'PrimaryBeneLastName',
  'PrimaryBeneRelationship',
  'PrimaryBeneCompanyName',
  'PrimaryBeneEIN',
  'PrimaryBeneEstateName',
  'PrimaryBeneTrustName',
  'PrimaryBeneTrustDate',
  'PrimaryBeneTrustTaxID',
  'ContingentBeneType',
  'ContingentBeneFirstName',
  'ContingentBeneMiddleName',
  'ContingentBeneLastName',
  'ContingentBeneRelationship',
  'ContingentBeneCompanyName',
  'ContingentBeneEIN',
  'ContingentBeneEstateName',
  'ContingentBeneTrustName',
  'ContingentBeneTrustDate',
  'ContingentBeneTrustTaxID',
  'ContingentBeneficiaryCheck',
  'BenefitPercentage',
];

export const FS_MASK_QUESTION_IDS_CLIENT = [
  'CoverageAmount',
  'Coverage',
  'ConfirmationNumber',
  'ExistingPolicies',
  'BillingMode',
  'PremiumPerMode',
  'Accept',
  'Review',
  'PremiumFrequencyForGIWL',
  'PremiumFrequencyForOtherProducts',
  'AnnualPremiumForGIWL',
  'MonthlyPremiumForGIWL',
  'AnnualPremiumForOtherProducts',
  'MonthlyPremiumForOtherProducts',
  'SemiAnnualPremiumForOtherProducts',
  'OfferProductType',
  'OfferCoverageType',
  'OfferFaceAmount',
  'MemberFirstName',
  'MemberMiddleInitial',
  'MemberJoinYear',
  'MemberJoinMonth',
  'MemberLastName',
  'MemberDateOfBirth',
  'MemberStreetAddress',
  'MemberGender',
  'MemberAddress2',
  'MemberCity',
  'MemberState',
  'MemberZIPCode',
  'MemberPhoneType',
  'MemberPhoneNumber',
  'MemberEmailAddress',
  'BeneDateOfBirth',
  'PrimaryBeneDateOfBirth',
  'ContingentBeneDateOfBirth',
  'BeneFirstName',
  'BeneFirstNameASGIWL',
  'BeneMiddleName',
  'BeneLastName',
  'BeneLastNameASGIWL',
  'BeneRelationship',
  'BeneStreetAddress',
  'BeneAddress2',
  'BeneCity',
  'BeneState',
  'BeneZIPCode',
  'PrimaryBeneType',
  'PrimaryBeneFirstName',
  'PrimaryBeneMiddleName',
  'PrimaryBeneLastName',
  'PrimaryBeneRelationship',
  'PrimaryBeneCompanyName',
  'PrimaryBeneEIN',
  'PrimaryBeneEstateName',
  'PrimaryBeneTrustName',
  'PrimaryBeneTrustDate',
  'PrimaryBeneTrustTaxID',
  'ContingentBeneType',
  'ContingentBeneFirstName',
  'ContingentBeneMiddleName',
  'ContingentBeneLastName',
  'ContingentBeneRelationship',
  'ContingentBeneCompanyName',
  'ContingentBeneEIN',
  'ContingentBeneEstateName',
  'ContingentBeneTrustName',
  'ContingentBeneTrustDate',
  'ContingentBeneTrustTaxID',
  'ContingentBeneficiaryCheck',
  'BenefitPercentage',
  'SecFirstName',
  'SecMiddleInitial',
  'SecLastName',
  'SecStreetAddress',
  'SecAddress2',
  'SecCity',
  'SecState',
  'SecZIPCode',
  'SecPhoneType',
  'SecPhoneNumber',
  'SecEmailAddress',
  'SelectedCoverage',
  'PaymentInfoGroup',
  'PremiumMonthly',
  'PremiumAnnual',
  'PremiumSemiAnnual',
  'DeductChecking',
  'NameOnChecking',
  'RoutingNumber',
  'AccountNumber',
  'DeductCard',
  'NameOnCard',
  'CreditCardNumber',
  'ExpiryDate',
];
